import { Fragment } from "react";
import Carousel from "../components/Carousel";
import SectionAbout from "../components/SectionAbout";
import ServicesCard from "../components/ServicesCard";
import SectionContact from "../components/SectionContact";
import ProjectGallery from "../components/ProjectGallery";
import VisionMissionValues from "../components/VisionMissionValues";
import WhySteelx from "../components/WhySteelx";

const Home = () => {
    return (
        <Fragment>
            <Carousel/>
            <SectionAbout />
            <VisionMissionValues/>
            <ServicesCard />
            <WhySteelx />
            <ProjectGallery />
            <SectionContact />
        </Fragment>
    );
}

export default Home;